import Plyr from 'plyr';

export default () => {
    const player = new Plyr('#player', {

    });

    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
    lazyVideos.forEach(function(video) {
        
        for (var source in video.children) {
            var videoSource = video.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
            }        

            video.load();
            video.classList.remove("lazy");            
        }
    });
      
    
};